export const commonTranslations = {
  // Common actions
  Save: 'Save',
  Update: 'Update',
  Delete: 'Delete',
  Cancel: 'Cancel',
  Create: 'Create',
  Edit: 'Edit',
  Copy: 'Copy',
  Download: 'Download',
  Upload: 'Upload',
  Send: 'Send',
  Apply: 'Apply',
  Filter: 'Filter',
  Search: 'Search',
  Add: 'Add',
  Remove: 'Remove',
  Accept: 'Accept',

  // Common states
  Loading: 'Loading',
  Error: 'Error',
  Success: 'Success',
  Failed: 'Failed',
  Completed: 'Completed',
  Processing: '{{documentCount}} Processing',
  Uploading: 'Uploading...',
  Generating: 'Generating',
  ItMayTakeUpTo10MinutesToComplete: 'Up to 10 minutes',

  // Common messages
  AnErrorOccurred: 'An error occurred!',
  PleaseTryAgain: 'Please try again.',
  CopiedToClipboard: 'Copied to clipboard',
  ErrorOccurred: 'The following error occurred.',
  DocumentNotFound: 'Document not found',

  // Time periods
  Today: 'Today',
  Yesterday: 'Yesterday',
  LastWeek: 'Last 7 days',
  LastMonth: 'Last 30 days',
  All: 'All',

  // Summary and status
  NoSummaryHistory: 'No summary history',
  SummaryGenerated: 'Summary Generated',
  SummaryGenerationFailed: 'Generation Failed',
  SummaryGenerationSuccessNoSummary:
    'Generation Complete - No Summary Available',
  AnalyzingYourDocument: 'Analyzing your document…',
  AnalyzingYourDocumentDesc:
    'AI is reviewing the content to generate a summary.',
  SummaryGenerationFailedDesc:
    ' Please try again, or check your input and attempt the process once more.',
  NoSummaryAvailable: 'No Summary Available',
  NoSummaryAvailableDesc:
    'We couldn’t generate a summary from this document. Please check the content.',
  UploadFailedSummary: 'Upload Failed',
  UploadFailedSummaryDesc: 'Please try again or double-check your file.',
  UploadAgain: 'Upload again',

  // Import
  ImportTitle: '⚠️ Importing a file will reset all existing content.',
  ImportConfirmation: ' Do you want to continue?',

  // Terms and Conditions
  TMCTitle: 'Notice Regarding Cheiron Terms of Service Update',
  'TMCTitleDesc.before':
    'To continue using Cheiron, please review and agree to the updated',
  'TMCTitleDesc.terms': 'Terms of Use',
  'TMCTitleDesc.and': 'and',
  'TMCTitleDesc.privacy': 'Privacy Policy',
  'TMCTitleDesc.after': '.',
  TMCAccept: 'I agree to the updated terms',
  Confirm: 'Confirm',

  // Update Document
  DocumentUpdatedSuccessfully: 'Document updated successfully',
  DocumentUpdateFailed: 'Document update failed',
  LabelingRetryFailed: 'Labeling retry failed',
}
